type ApiError = { error: string; message?: string; issues?: Record<string, string[]> };

export class ApiCallError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: ApiError
  ) {
    super(body.error);
    this.name = 'ApiCallError';
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    ...init,
  });

  if (!res.ok) {
    const body = (await res.json().catch(() => ({ error: 'unknown_error' }))) as ApiError;
    throw new ApiCallError(res.status, body);
  }
  return res.json() as Promise<T>;
}
